import { get, postAPI, putAPI, deleteAPI } from "../services/api.services";
import Swal from "sweetalert2";
const { defaultPage } = require('../Common/Constant');

export const blogCategoryList = async({page=defaultPage.current_page, recPerPage=defaultPage.perPage, searchKeyword = ""}) => {
    let data = {
        page: page,
        recPerPage: recPerPage,
        q: searchKeyword
    }
    let res = await postAPI('/blog-category/list', data)
    return res;
}

export const blogCategoryDetails = async({payload}) => {
    let res = await get('/blog-category/details/'+payload);
    return res;
}

export const blogCategoryDelete = async({id}) => {
    return Swal.fire({
        text: 'Are you sure you want to delete?',
        confirmButtonText: 'Yes',
        showCancelButton: true,
    }).then(async (result) => {
        if (result.value) {
            let res = await deleteAPI('/blog-category/delete/'+id)
            return Swal.fire({
                text:res.message,
                timer: 1500,
            }).then(() => {
                return res;
            })
        }
    })
}

export const blogCategoryUpdateStatus = async({id, status}) => {
    return Swal.fire({
        text: 'Are you sure you want to update?',
        confirmButtonText: 'Yes',
        showCancelButton: true,
      }).then(async (result) => {
        if (result.value) {
            let res = await putAPI('/blog-category/update-status/'+id+'/'+status)
            return Swal.fire({
                text:res.message,
                timer: 1500,
            }).then(() => {
                return res;
            })
        }
      })
}

export const blogCategoryCreate = async({payload}) => {
    let res = await postAPI('/blog-category/add', payload)
    return Swal.fire({
        text:res.message,
        timer: 1500,
    }).then(() => {
        return res;
    })
}

export const blogCategoryUpdate = async({payload}) => {
    let ID = payload?.id;
    delete payload.id;

    let res = await putAPI('/blog-category/update/'+ID, payload)
    return res;
}

export const blogCategoryCheckName = async({name, id = 0}) => {
    let data = {
        name: name,
        id: id
    }
    let res = await postAPI('/blog-category/check-unique', data);
    return res;
}

// export const mappedBlogCategoryAttributeSet = async({id}) => {
//     let res = await get('/blog-category/mapping/'+id);
//     return res;
// }

// export const mappedBlogCategoryAttributes = async({id}) => {
//     let res = await get('/blog-category/mapped-attributes/'+id);
//     return res;
// }

// export const mapBlogCategoryAttributeSet = async({id, attributeSetIDArr}) => {
//     let data = {
//         attributeSetIDArr: attributeSetIDArr
//     };
//     let res = await putAPI('/blog-category/mapping/'+id, data);
//     return res;
// }

export const getParentCategoriesList = async() => {
    let res = await get('/get-parent-categories/');
    return res;
}